const asyncComponentFactory = (handle) => {
  return (node, ctx) => {
    return import(
      /* webpackChunkName: "[request]" */
      /* webpackMode: "lazy" */
      `./components/${handle}`
    ).then((module) => {
      const instance = module.default(node, ctx);
      const unsubscribe = ctx.on("unmount", () => {
        instance.unmount();
        unsubscribe();
      });
    });
  };
};

// UI COMPONENTS ==============================================================
import Slider from "./components/ui/Slider";
import Collage from "./components/ui/Collage";
import MediaPlayer from "./components/media/MediaPlayer";
import Technology from "./components/ui/Technology";
import Features from "./components/ui/Features";
import FreeGiftModal from "./components/ui/FreeGiftModal";
import ProductCarousel from "./components/ui/ProductCarousel";
// import Modal from "./components/ui/Modal";
import EasterBundle from "./components/ui/EasterBundle";
import WalliBundle from "./components/ui/WalliBundle";
import NewCustomizer from "./components/ui/NewCustomizer";
// NAV COMPONENTS ==============================================================

export const AppComponents = {
  // NAV COMPONENTS ==============================================================

  // Content Components ------------------------------------------------------------

  // PRODUCT Components ---------------------------------------------------------

  // MEDIA Components ------------------------------------------------------------
  Collage,
  Slider,
  // MediaPlayer,
  Technology,
  Features,
  // Modal,

  // UI Components ------------------------------------------------------------
  ProductCarousel,
  FreeGiftModal,
  EasterBundle,
  WalliBundle,
  NewCustomizer
};
